'use strict';

// Один и тот же ответ не затирает правку. Новый ответ (другой token) записывается всегда.
function tzFillDecision(stamp, token, nodeValue, nextValue) {
    if (stamp && stamp === token && nodeValue !== nextValue) return 'keep';
    if (nodeValue === nextValue) return 'same';
    return 'write';
}

module.exports = { tzFillDecision };
